import React, {Component} from "react";
import $ from "jquery";

class SideLeft extends Component {
	componentDidMount() {
		// TODO:scroll
		const coupon = $('.body__container__side-left .fixed');
		$(window).scroll(function () {
			if ( window.pageYOffset >= 40 ) {
				coupon.parent().addClass('event-id');
			} else {
				coupon.parent().removeClass('event-id');
			}
		});
	}

	render() {
		const {children} = this.props;

		return (
			<div className="body__container__side-left">
				{children}
			</div>
		);
	}
}

export default SideLeft;


// WEBPACK FOOTER //
// ./src/app/SideLeft.js